<template>
    <div>
        <section class="page-header profile_page">
            <div class="container">
                <div class="page-header_wrap page2">
                    <div class="page-heading">
                        <h1>Formulario Solicitud de Credito</h1>
                    </div>
                    <ul class="coustom-breadcrumb">
                        <li><a href="#">Cliente</a></li>
                        <li>Nombre Apellido</li>
                    </ul>
                </div>
            </div>
            <!-- Dark Overlay-->
            <div class="dark-overlay"></div>
        </section>
        <div class="space-20"></div>
        <form action="">
            <div class="container">
                <b-card class="mb-2">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label for="">Fecha</label>
                                <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder=""
                                />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label for="">Ciudad</label>
                                <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder=""
                                />
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <datosFinanciacionForm />
                <datosPersonalesForm />
                <actividadEconomicaForm />
                <informacionFinancieraForm />
                <referenciasForm />
                <b-card class="mb-2" header-tag="header">
                    <template #header>
                        <h6 class="mb-0 text-center">
                            <i class="fa fa-user-secret"></i> Autorización de
                            consulta y tratamiento de información
                        </h6>
                    </template>
                    <b-row>
                        <b-col>
                            <p>
                                Pendiente que entreguen el parrafo con la
                                información
                            </p>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card>
                    <b-row>
                        <b-col md="6" cols="12">
                            <b-button block>
                                Anexar Documento de Identificación
                            </b-button>
                        </b-col>
                        <b-col md="6" cols="12">
                            <b-row>
                                <b-col md="12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            disabled
                                            placeholder="Nombre Completo Solicitante"
                                        />
                                    </div>
                                </b-col>
                                <b-col md="12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            disabled
                                            placeholder="Tipo Doc - Nro Documento"
                                        />
                                    </div>
                                </b-col>
                                <b-col md="12" class="text-center">
                                    <a href="">
                                        <h6>
                                            <i class="fa fa-pencil"></i> Firma
                                            Digital
                                        </h6>
                                    </a>
                                </b-col>
                                <b-col md="12" class="text-center">
                                    <b-button block>
                                        Enviar Formulario
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </form>
    </div>
</template>

<script>
import datosFinanciacionForm from "./frontDatosFinanciacionForm";
import datosPersonalesForm from "./frontDatosPersonalesForm";
import actividadEconomicaForm from "./frontActividadEconomicaForm";
import informacionFinancieraForm from "./frontInformacionFinancieraForm";
import referenciasForm from "./frontReferenciasForm";

export default {
    components: {
        datosFinanciacionForm,
        datosPersonalesForm,
        actividadEconomicaForm,
        informacionFinancieraForm,
        referenciasForm
    }
};
</script>

<style lang="scss">
.page-header_wrap.page2 {
    padding: 30px;
}
</style>
